import { Button, Form, Modal } from 'antd';
import React from 'react';
import { changeCycleDay } from 'src/apis/Reporting/BillingDate';
import BillingDateForm from 'src/components/Reporting/BillingDateForm';

interface ILocalProps {
    currentDay: number;
    customerID: number;
    customerName: string;
    handleClose: () => void;
    handleSubmit: () => void;
}

interface ILocalState {
    loading: boolean;
    responseMessage: string;
}

class BillingDateModal extends React.Component<ILocalProps, ILocalState> {
    public state = { loading: false, responseMessage: '' };

    public formReference: Form | null = null;

    public handleClose = () => {
        this.props.handleClose();
    };

    public handleSubmit = () => {
        const { customerID } = this.props;
        if (this.formReference !== null && this.formReference.props.form) {
            this.formReference.props.form.validateFields({ force: true }, async (err, values) => {
                if (err) {
                    const message = err.toString() === '[object Object]' ? '' : err.toString();
                    this.setState({ responseMessage: message, loading: false });
                    return;
                }
                this.setState({ loading: true });
                const response = await changeCycleDay(
                    values.newCycleDay,
                    customerID
                );
                this.setState({ responseMessage: response.message, loading: false });
                if (response.success) {
                    this.props.handleSubmit();
                }
            });
        }
    };

    public saveFormRef = (formReference: Form) => {
        this.formReference = formReference;
    };

    public render() {
        const title = 'Change Billing Date for ' + this.props.customerName;
        return (
            <Modal
                closable={false}
                title={title}
                visible={true}
                className="modal"
                footer={[
                    <Button key="close" onClick={this.handleClose} style={{ float: 'left' }}>Close</Button>,
                    <Button key="submit" loading={this.state.loading} onClick={this.handleSubmit} type="primary">Submit</Button>,
                ]}
            >
                <BillingDateForm
                    currentDay={this.props.currentDay}
                    wrappedComponentRef={this.saveFormRef}
                />
                <span className="errorMessage">{this.state.responseMessage}</span>
            </Modal>
        );
    }
}

export default BillingDateModal;
